import { render, staticRenderFns } from "./RootContent.vue?vue&type=template&id=cbc1e67a&"
import script from "./RootContent.vue?vue&type=script&lang=js&"
export * from "./RootContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports